import { useOrganization, useUser } from '@clerk/clerk-react'

import { useCanAdministerPermissions } from '@/hooks/useCanAdministerPermissions'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import type { ReactNode } from 'react'

interface ProtectedPermissionsRouteProps {
  children: ReactNode
}

/**
 * The permissions matrix, open to whoever the server's `_matrix_scope` admits.
 *
 * Wider than `ProtectedGlobalAdminRoute`, which keys on the active-org role
 * alone: that leaves out Careforce staff working inside a customer org, who
 * are the only way back in when an org's own admin locks themselves out.
 */
export function ProtectedPermissionsRoute({
  children,
}: ProtectedPermissionsRouteProps) {
  const { isLoaded: userLoaded } = useUser()
  const { isLoaded: orgLoaded } = useOrganization()
  const canAdminister = useCanAdministerPermissions()

  return (
    <ProtectedRoute
      allowed={userLoaded && orgLoaded ? canAdminister : undefined}
      message="You need admin access to view this page."
      toastId="permissions-access-denied">
      {children}
    </ProtectedRoute>
  )
}
